import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    response: null,
    error: null,
    campaignList: null,
    showCampaign: null,
    candidateList: null,
    showData: null,

};
// {campaign list}
export const fetchCampaignlist = createAsyncThunk(
    "fetchCampaignlist",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/etecampaign/ete-campaign-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
// {dashboard campaign show}
export const fetchDashboardCampaign = createAsyncThunk(
    "fetchDashboardCampaign",
    async (id) => {
        try {
            const response = await axios.get(
                `https://apiai.remarkhr.com/meta_px/ads-dashboard/${id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
// {Generate job poster}
export const generateJobPoster = createAsyncThunk(
    "generateJobPoster ",
    async (data) => {
        try {
            const res = await axios.post("https://apiai.remarkhr.com/meta_px/generate-job-poster", data);
            return res?.data;
        } catch (error) {
            throw error;
        }
    }
);
// {Launch Campaign}
export const launchCampaign = createAsyncThunk(
    "launchCampaign",
    async (data) => {
        try {
            const response = await axios.post("https://apiai.remarkhr.com/meta_px/create-campaign", data);
            return response.data;
        } catch (err) {
            throw err;
        }
    }
);
// {save campaign details }
export const saveCampaignDetails = createAsyncThunk(
    "saveCampaignDetails",
    async (data) => {
        try {
            console.log(data, "data56");

            const response = await instance.post(
                "remark/etecampaign/create-ete-campaign",
                data,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
            return response.data;
        } catch (err) {
            throw err;
        }
    }
)

// {Updtae camapign status}

export const updateCampaignStatus = createAsyncThunk(
    "updateCampaignStatus",
    async (body) => {
        try {
            const response = await instance.post(
                `/remark/etecampaign/updated-ete-campaign-status`, body
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

// {Delete Campaign list}
export const deleteCampaignDetails = createAsyncThunk(
    "deleteCampaignDetails",
    async (body) => {
        try {
            const response = await instance.post(
                `/remark/etecampaign/delete-campaign`, body
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
//Update Campaign Details
export const updateCampaignDetails = createAsyncThunk(
    "updateCampaignDetails",
    async (data) => {
        try {

            const response = await instance.post(
                "remark/etecampaign/updated-ete-campaign",
                data,
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
            return response.data;
        } catch (err) {
            throw err;
        }
    }
)

// {show applied candidate api}
export const fetchAllAppliedCandidate = createAsyncThunk(
    "fetchAllAppliedCandidate",
    async (eh_campaign_id) => {
        try {
            const response = await instance.get(
                `/remark/etecampaign/ete-campaign-applied-user-list?campaign_id=${eh_campaign_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
// {start Camapaign}

export const startCampaign = createAsyncThunk(
    "startCampaign",
    async (data) => {
        try {

            const response = await axios.post("https://apiai.remarkhr.com/meta_px/start-campaign", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

// {Stop Campaign}
export const stopCampaign = createAsyncThunk(
    "stopCampaign",
    async (data) => {
        try {

            const response = await axios.post("https://apiai.remarkhr.com/meta_px/pause-campaign", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

// {Delete Camapign }
export const deleteCampaign = createAsyncThunk(
    "deleteCampaign",
    async (data) => {
        try {

            const response = await axios.post("https://apiai.remarkhr.com/meta_px/delete-campaign", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const NewEndToEndHiringSlice = createSlice({
    name: "NewEndToEndHiringSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(generateJobPoster.pending, (state) => {
            state.loading = true;

        });
        builder.addCase(generateJobPoster.fulfilled, (state, action) => {

            state.loading = false;
            state.response = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(generateJobPoster.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(fetchCampaignlist.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCampaignlist.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(fetchCampaignlist.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(fetchDashboardCampaign.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchDashboardCampaign.fulfilled, (state, action) => {
            state.loading = false;
            state.showCampaign = action?.payload;

        });
        builder.addCase(fetchDashboardCampaign.rejected, (state, action) => {
            state.loading = false;
        });

        builder.addCase(launchCampaign.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(launchCampaign.fulfilled, (state, action) => {
            state.loading = false;
            state.campaignList = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(launchCampaign.rejected, (state, action) => {
            state.loading = false;
        });

        builder.addCase(saveCampaignDetails.pending, (state) => {
            state.loading = true;

        });
        builder.addCase(saveCampaignDetails.fulfilled, (state, action) => {

            state.loading = false;
            state.response = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(saveCampaignDetails.rejected, (state, action) => {
            state.loading = false;
        });

        builder.addCase(updateCampaignStatus.pending, (state) => {
            state.loading = true;

        });
        builder.addCase(updateCampaignStatus.fulfilled, (state, action) => {

            state.loading = false;
            state.response = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(updateCampaignStatus.rejected, (state, action) => {
            state.loading = false;
        });


        builder.addCase(updateCampaignDetails.pending, (state) => {
            state.loading = true;

        });
        builder.addCase(updateCampaignDetails.fulfilled, (state, action) => {

            state.loading = false;
            state.response = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(updateCampaignDetails.rejected, (state, action) => {
            state.loading = false;
        });

        builder.addCase(deleteCampaignDetails.pending, (state) => {
            state.loading = true;

        });
        builder.addCase(deleteCampaignDetails.fulfilled, (state, action) => {

            state.loading = false;
            state.response = action?.payload;

        });
        builder.addCase(deleteCampaignDetails.rejected, (state, action) => {
            state.loading = false;
        });



        builder.addCase(fetchAllAppliedCandidate.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllAppliedCandidate.fulfilled, (state, action) => {
            state.loading = false;
            state.candidateList = action?.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(fetchAllAppliedCandidate.rejected, (state, action) => {
            state.loading = false;
        });

        builder.addCase(deleteCampaign.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteCampaign.fulfilled, (state, action) => {
            state.loading = false;
            state.showData = action?.payload;

        });
        builder.addCase(deleteCampaign.rejected, (state, action) => {
            state.loading = false;
        });
        // builder.addCase(startCampaign.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(startCampaign.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.showData = action?.payload;

        // });
        // builder.addCase(startCampaign.rejected, (state, action) => {
        //     state.loading = false;
        // });

        // builder.addCase(stopCampaign.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(stopCampaign.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.showData = action?.payload;

        // });
        // builder.addCase(stopCampaign.rejected, (state, action) => {
        //     state.loading = false;
        // });
    },
});
export default NewEndToEndHiringSlice.reducer;
